import { memo, useState } from "react";
import {
    Box,
    Select,
    IconButton,
    Button,
    Flex,
    Icon,
    Tooltip,
} from "@chakra-ui/react";
import { FaCheckCircle, FaEdit, FaEye, FaEyeSlash, FaLanguage, FaMinusCircle, FaPlus } from "react-icons/fa";
import MenuSections from "./MenuSections";
import TranslationModal from "./TranslationModal";

const MenuTabs = ({ menus, onEdit, onDeactivate }) => {
    const [selectedIndex, setSelectedIndex] = useState(0);
    const [translationMenu, setTranslationMenu] = useState(null);
    const selectedMenu = menus[selectedIndex] || menus[0];

    return (
        <Box>
            <Flex align="center" gap={2} px={4} mb={4} wrap="wrap">
                <Select
                    value={selectedIndex}
                    onChange={(e) => setSelectedIndex(Number(e.target.value))}
                    width="auto"
                    flexShrink={0}
                    bg="white"
                >
                    {menus.map((menu, index) => (
                        <option key={menu.id} value={index}>
                            {menu.name}
                        </option>
                    ))}
                </Select>

                {selectedMenu && (
                    <>
                        <Tooltip label={selectedMenu.isActive ? "Aktivno" : "Neaktivno"} fontSize="sm">
                            <span>
                                <Icon
                                    as={selectedMenu.isActive ? FaCheckCircle : FaMinusCircle}
                                    color={selectedMenu.isActive ? "green.400" : "gray.400"}
                                    boxSize={5}
                                    verticalAlign="middle"
                                />
                            </span>
                        </Tooltip>
                        <IconButton
                            icon={<FaEdit />}
                            size="sm"
                            aria-label="Edit menu"
                            onClick={() => onEdit("menu", selectedMenu)}
                        />
                        <IconButton
                            icon={selectedMenu.isActive ? <FaEyeSlash /> : <FaEye />}
                            size="sm"
                            aria-label={selectedMenu.isActive ? "Deactivate menu" : "Activate menu"}
                            onClick={() => onDeactivate("menu", selectedMenu)}
                        />
                        <IconButton
                            icon={<FaLanguage />}
                            size="sm"
                            aria-label="Translate menu"
                            onClick={() => setTranslationMenu(selectedMenu)}
                        />
                    </>
                )}
            </Flex>

            {selectedMenu && (
                <Box px={4}>
                    <MenuSections
                        sections={selectedMenu.sections}
                        onEdit={onEdit}
                        onDeactivate={onDeactivate}
                    />
                    <Flex justify="center" mt={6}>
                        <Button
                            leftIcon={<FaPlus />}
                            bg="transparent"
                            color="brand.700"
                            border="1px solid #154360"
                            borderRadius="full"
                            size="sm"
                            _hover={{ bg: "brand.50" }}
                            onClick={() =>
                                onEdit("section", {
                                    name: "",
                                    header: "",
                                    description: "",
                                    menuId: selectedMenu.id,
                                })
                            }
                        >
                            Add Section
                        </Button>
                    </Flex>
                </Box>
            )}

            {translationMenu && (
                <TranslationModal
                    entityType="menu"
                    entity={translationMenu}
                    onClose={() => setTranslationMenu(null)}
                />
            )}
        </Box>
    );
};

export default memo(MenuTabs);
